var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 272",
    style: {
      enableBackground: "new 0 0 288 272"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B6E86;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "cross-sign_1_",
    transform: "translate(1069 297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    className: "st0",
    d: "M-866.5-213.9l-8.3-8.8c-2.1-2.3-5.7-2.4-8-0.3c-0.1,0.1-0.2,0.2-0.3,0.3l-41.5,44.4 l-42.3-45.2c-2.1-2.3-5.7-2.4-8-0.3c-0.1,0.1-0.2,0.2-0.3,0.3l-8.3,8.9c-2.3,2.5-2.3,6.4,0,8.9l42.2,45.1l-41.3,44.5 c-2.3,2.5-2.3,6.4,0,8.9l8.3,8.9c2.1,2.3,5.7,2.4,8,0.3c0.1-0.1,0.2-0.2,0.3-0.3l41.4-44.4l41.5,44.4c2.1,2.3,5.7,2.4,8,0.3 c0.1-0.1,0.2-0.2,0.3-0.3l8.3-8.9c2.3-2.5,2.3-6.4,0-8.9l-41.7-44.4l41.5-44.4C-864.2-207.5-864.2-211.4-866.5-213.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,266c-71.7,0-130-58.3-130-130S72.3,6,144,6c71.7,0,130,58.3,130,130S215.7,266,144,266z M144,23 C81.7,23,31,73.7,31,136s50.7,113,113,113s113-50.7,113-113S206.3,23,144,23z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross_circle.559eb872.svg";
export { ForwardRef as ReactComponent };